<template>
  <div class="tour-item">
    <div class="tour-item__bg"></div>
    <section class="grid grid--container">
      <div class="row row--lg-center row--md-h-center">
        <div :class="`col ${contentCol}`">
          <div
            :class="`tour-item__content ${
              right ? 'tour-item__content--right' : ''
            }`"
          >
            <slot />
          </div>
        </div>
        <div
          :class="`col ${mediaCol} ${
            right ? 'col--lg-first' : ''
          } text--xs-center`"
        >
          <slot name="media" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    right: Boolean,
    contentCol: {
      type: String,
      default: 'col--lg-6 col--md-10',
    },
    mediaCol: {
      type: String,
      default: 'col--lg-6',
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-item {
  border-bottom: 1px solid #cfd5e1;
  font-size: 1.125rem;
  padding: 2rem 0;
  position: relative;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: 3.125rem 0;
  }

  &--2,
  &--3 {
    padding-bottom: 0;
  }

  .col {
    position: relative;
  }

  .h1 {
    color: var(--g-color-primary);
    margin-bottom: 1.875rem;
  }
}

.tour-item__bg {
  background: var(--g-color-gray-100);
  background-image: url('~assets/images/mark-pattern-white.svg');
  background-size: 80px auto;
  height: 100%;
  left: 0;
  opacity: 0.3;
  position: absolute;
  top: 0;
  width: 100%;
}

.tour-item__content {
  font-size: 18px;
  line-height: 1.8;
  position: relative;
  text-align: center;

  p,
  ul {
    margin: 0.625rem 0;
  }

  ul {
    list-style: none;
    padding-left: 0;
  }

  .btn {
    margin-top: 1.25rem;
  }
}

.tour-item__img,
.tour-item__device-wrapper {
  margin-top: 1.875rem;
}

.tour-item__device-wrapper {
  height: 524px;
  position: relative;
}

.tour-item__phone {
  left: 50%;
  top: 0;
  transform: translateX(-50%) scale(0.6);
  transform-origin: center top;
}

@media (min-width: 992px) {
  .tour-item {
    padding: 5rem 0;

    &--2,
    &--3 {
      padding-bottom: 0;
    }
  }

  .tour-item__content {
    font-size: 20px;
    padding-right: 3.125rem;
    text-align: left;

    &--right {
      padding-right: 1.25rem;
      padding-left: 3.125rem;
    }
  }

  .tour-item__device-wrapper {
    height: 700px;
    margin-top: 0;
  }

  .tour-item__phone {
    transform: translateX(-50%) scale(0.8);
  }

  .tour-item__img-wrapper {
    min-height: 41.25rem;
  }

  .tour-item__img {
    box-shadow: -1px 1px 2px rgba(0, 0, 0, 0.2);
    margin-top: 0;
    max-width: auto;
    max-width: unset;

    &--left {
      box-shadow: 1px -1px 2px rgba(0, 0, 0, 0.2);
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
</style>
